// ════════════════════════════════════════════════════════════
//  ui/Callouts.jsx — a trainer's calls under the names bar
// ════════════════════════════════════════════════════════════
//  LYRAEI PLAYS (2026-10-17): when a partner plays she calls her shots
//  ("Ascend!", "Switch to Raeyn'ao!"); they float under her name for a
//  few seconds (online/callouts.js), stacked in the middle under the
//  clock, coloured like the names bar (yours gold, theirs pink).
//  Hide-able like every piece (caP'n 2026-10-17): the "calls" piece.
// ════════════════════════════════════════════════════════════
import { useEffect, useState } from "react";
import { useCalls, CALL } from "../online/callouts.js";
import { serverNow } from "../online/ie.js";
import HideBtn from "./HideBtn.jsx";
import "./callouts.css";

export default function Callouts({ battle, mySide }) {
  const calls = useCalls(battle);
  const [, tick] = useState(0);
  const now = serverNow();
  const live = (c) => c && now - c.t >= -2000 && now - c.t < CALL.show * 1000;
  const any = !!(live(calls[0]) || live(calls[1]));   // the timer runs only while a call is up (then one last tick hides it)
  useEffect(() => { if (!any) return undefined; const id = setInterval(() => tick((n) => n + 1), 300); return () => clearInterval(id); }, [any]);
  const b = battle && battle.current;
  const shown = [mySide, 1 - mySide].filter((s) => live(calls[s]));
  if (!shown.length) return null;
  return (
    <div className="callouts">
      {shown.map((s) => (
        <div key={s + ":" + calls[s].t} className={"callout " + (s === mySide ? "left" : "right")}>
          <b>{b && b.sides[s] ? b.sides[s].name : ""}</b> “{calls[s].x}”
        </div>
      ))}
      <HideBtn id="calls" />
    </div>
  );
}
